import React, {Component} from "react";
import {FormDate, Modal, FormSelect} from "@frostbyte-technologies/frostbyte-tailwind";
import {Formik} from "formik";
import {request} from "../../../utils/request";
import * as Yup from "yup";
import moment from "moment/moment";

class BreakModal extends Component {
  state = {breakItem: null, timesheet: null};

  async open(breakItem) {
    this.setState({breakItem}, () => {
      this.formikRef && this.formikRef.resetForm();
      this.modal.open();
    });
  }

  async add(timesheet) {
    this.setState({timesheet}, () => {
      this.formikRef && this.formikRef.resetForm();
      this.modal.open();
    });
  }

  async createBreak({breakOption, start, end, isPaid}) {
    const {timesheet} = this.state;

    const payload = {
      BREAK_OPTION_ID: breakOption,
      DATE_START: start,
      DATE_END: end,
      IS_PAID: isPaid,
    };

    try {
      const serverBreak = await request("team/break/" + timesheet.ID, "POST", payload);

      this.props.updateBreaks(serverBreak);
    } catch (err) {
      alert("Error trying to process break");
      console.log(err);
    }

    this.modal.close();
  }

  async saveBreak({start, end, isPaid}) {
    const {breakItem} = this.state;

    const payload = {
      DATE_START: start,
      DATE_END: end,
      IS_PAID: isPaid,
    };

    let serverBreak;

    try {
      serverBreak = await request("team/break/" + breakItem.ID, "PATCH", payload);

      if (this.props.updateBreaks) {
        this.props.updateBreaks(serverBreak);
      }
    } catch (error) {
      alert("Failed to update break. Please try again or contact Dripos for support");
      console.log(error);
    }

    this.modal.close();
  }

  render() {
    const {breakItem, timesheet} = this.state;
    const {breakOptions} = this.props;

    const timesheetDateEnd = timesheet?.DATE_END ?? this.props.timesheet?.DATE_END;

    let initialValues = {
      start: breakItem?.DATE_START,
      end: breakItem?.DATE_END,
      isPaid: breakItem?.IS_PAID ? true : false,
    };

    return (
      <Modal
        buttonLabel={"Save"}
        label={breakItem ? "Edit Break" : "Create Break"}
        ref={(e) => (this.modal = e)}
        formikOnClick={() => this.formikRef}
      >
        <Formik
          onSubmit={breakItem ? this.saveBreak.bind(this) : this.createBreak.bind(this)}
          innerRef={(e) => (this.formikRef = e)}
          enableReinitialize
          initialValues={initialValues}
          validationSchema={Yup.object().shape({
            start: Yup.string()
              .required()
              .test("Range Check", "Please enter a value within the timecard times", (val) => {
                return parseInt(val) >= (timesheet?.DATE_START ?? this.props.timesheet.DATE_START);
              }),
            end: Yup.string()
              .required()
              .test("Range Check", "Please enter a value within the timecard times", (val) => {
                return timesheetDateEnd ? parseInt(val) <= timesheetDateEnd : true;
              }),
          })}
        >
          {(formikOptions) => {
            const {handleSubmit} = formikOptions;

            return (
              <form onSubmit={handleSubmit}>
                {breakOptions && breakOptions.length > 0 && (
                  <FormSelect
                    label={"Break Option"}
                    name="breakOption"
                    options={formikOptions}
                    data={breakOptions?.map((breakOption) => ({
                      label: breakOption.NAME,
                      value: breakOption.ID,
                    }))}
                  />
                )}

                <div className="flex flex-row justify-between">
                  <FormDate
                    label={"Date Start"}
                    options={formikOptions}
                    name="start"
                    showTime
                    timeIntervals={1}
                  />

                  <FormDate
                    label={"Date End"}
                    options={formikOptions}
                    name="end"
                    showTime
                    timeIntervals={1}
                  />
                </div>

                <FormSelect
                  options={formikOptions}
                  label="Is Break Paid"
                  name="isPaid"
                  data={[
                    {label: "Yes", value: true},
                    {label: "No", value: false},
                  ]}
                />
              </form>
            );
          }}
        </Formik>
      </Modal>
    );
  }
}

export default BreakModal;
